//Stateler çekilip return edilecek

export const getDealerLoading = (state) => {
    return state.loading
}

export const getDealerList = (state) => {
    return state.dealers
}